const addScriptA2 = async () => {
    const el = document.createElement('script');
    el.src = 'https://js.adsrvr.org/up_loader.1.1.0.js';
    el.async = 'true';
    el.addEventListener('load', function () {
        ttd_dom_ready(function () {
            if (typeof TTDUniversalPixelApi === 'function') {
                const universalPixelApi = new TTDUniversalPixelApi();
                universalPixelApi.init('dbnmac9', ['4xke7mc'], 'https://insight.adsrvr.org/track/up');
            }
        });
    });
    document.head.appendChild(el);
};
const addScriptA1 = () => {
    const el = document.createElement('script');
    el.src = 'https://p.teads.tv/teads-fellow.js';
    el.async = 'true';
    el.addEventListener('load', function () {
        window.teads_e = window.teads_e || [];
        window.teads_buyer_pixel_id = 14037;
    });
    document.head.appendChild(el);
};

export const addScriptAHandle = () => {
    //addScriptA1();
    addScriptA2();
};
